document.addEventListener('DOMContentLoaded', function() {

   // 无障碍：键盘切换 Radio 后，同步 T4S 原有变体逻辑
    if (!window.__t4sSwatchRadioBridgeBound) {
      window.__t4sSwatchRadioBridgeBound = true;
    
      document.addEventListener('change', function (event) {
        const radio = event.target;
        if (!radio.matches?.('.t4s-form__product .t4s-swatch__radio') || !radio.checked) return;
    
        const label = radio.labels?.[0];
        if (!label || !label.hasAttribute('data-swatch-item')) return;
    
        // 鼠标已选中的选项不重复触发
        if (label.classList.contains('is--selected')) return;
    
        // 触发 T4S 原有变体切换
        label.click();
      });
    }

})